import { CSSProperties } from "react";
import { Theme } from "@mui/material";

import { NestedCSSProperties } from "@interfaces/types/styles.types";

export const rootContainerStyles: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  maxWidth: "620px",
};

export const contentWrapperStyles = (theme: Theme): CSSProperties => ({
  backgroundColor: theme.palette.background.default,
  width: "100%",
  borderRadius: "8px",
  overflow: "hidden",
});

export const previewWrapperStyles: CSSProperties = {
  padding: "24px 24px 16px",
};

export const previewInputStyles = (
  theme: Theme
): CSSProperties | NestedCSSProperties => ({
  "& .MuiOutlinedInput-input": {
    fontSize: 22,
    color: theme.palette.text.primary,
  },
});

export const phonePrefixAdornmentStyles = (theme: Theme): CSSProperties => ({
  fontSize: 22,
  fontWeight: 700,
  color: theme.palette.text.primary,
});

export const suggestionsWrapperStyles: CSSProperties = {
  display: "flex",
  gap: "12px",
  padding: "0 24px 16px",
};

export const suggestionChipStyles = (theme: Theme): CSSProperties => ({
  flex: 1,
  minWidth: 0,
  padding: "10px 14px",
  borderRadius: "8px",
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.black,
  fontSize: "16px",
  fontWeight: 700,
  textAlign: "center",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  cursor: "pointer",
  userSelect: "none",
});

export const keyboardWrapperStyles = (
  theme: Theme
): CSSProperties | NestedCSSProperties => ({
  padding: "0 24px 24px",

  "& .hg-theme-default": {
    backgroundColor: "transparent",
    padding: 0,
  },
  "& .hg-button": {
    height: "48px",
    borderRadius: "6px",
    backgroundColor: theme.customColors.numpadButtonColor,
    color: theme.palette.common.white,
    fontSize: "18px",
    fontWeight: 700,
    boxShadow: "none",
  },
  "& .hg-key-accent": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.black,
  },
  "& .hg-key-space": {
    flexGrow: 5,
  },
  "& .hg-key-disabled": {
    backgroundColor: theme.customColors.inputDisabledBackgroundColor,
    color: theme.customColors.inputDisabledFontColor,
    opacity: 0.6,
    pointerEvents: "none",
  },
  "& .hg-button.hg-activeButton": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.black,
  },
});

export const numpadWrapperStyles = (
  theme: Theme
): CSSProperties | NestedCSSProperties => ({
  padding: "0 24px 24px",

  "& .hg-theme-default": {
    backgroundColor: "transparent",
    padding: 0,
  },
  "& .hg-row:not(:last-child)": {
    marginBottom: "12px",
  },
  "& .hg-row .hg-button:not(:last-child)": {
    marginRight: "12px",
  },
  "& .hg-button": {
    width: "0 !important",
    flex: "1 1 0 !important",
    height: "76px",
    borderRadius: "8px",
    backgroundColor: theme.customColors.numpadButtonColor,
    color: theme.palette.common.white,
    fontSize: "32px",
    fontWeight: 700,
    boxShadow: "none",
  },
  "& .hg-key-accent": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.black,
  },
  "& .hg-key-disabled": {
    backgroundColor: theme.customColors.inputDisabledBackgroundColor,
    color: theme.customColors.inputDisabledFontColor,
    opacity: 0.6,
    pointerEvents: "none",
  },
  "& .hg-button.hg-activeButton": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.black,
  },
});

export const footerStyles: CSSProperties = {
  display: "flex",
  width: "100%",
  minHeight: "80px",
};

export const cancelButtonStyles = (theme: Theme): CSSProperties => ({
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: theme.customColors.numpadButtonColor,
  color: theme.palette.common.white,
  fontSize: "18px",
  fontWeight: 700,
  letterSpacing: "1px",
  cursor: "pointer",
  userSelect: "none",
});

export const enterButtonStyles = (theme: Theme): CSSProperties => ({
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.black,
  fontSize: "18px",
  fontWeight: 700,
  letterSpacing: "1px",
  cursor: "pointer",
  userSelect: "none",
});
